import { CreditCard, CalendarCheck, Users, QrCode, Bike, Heart, Share2, Globe, BarChart3, Package } from 'lucide-react';

export const TOPIC_ICONS = { CreditCard, CalendarCheck, Users, QrCode, Bike, Heart, Share2, Globe, BarChart3, Package };
